export type LiveChange = { collection: string; action: string; key: string };

export function liveEventType(action: string): "created" | "updated" | "deleted" {
  if (action === "INSERT") return "created";
  if (action === "DELETE") return "deleted";
  return "updated";
}

export function parseLiveBlock(block: string): LiveChange | null {
  if (!block.startsWith("data: ")) return null;
  try {
    const value = JSON.parse(block.slice(6));
    if (!value || typeof value.collection !== "string" || typeof value.key !== "string") return null;
    return { collection: value.collection, action: value.action, key: value.key };
  } catch {
    return null;
  }
}

export function eventsUrl(directusUrl: string): string {
  return `${directusUrl.replace(/\/$/, "")}/events`;
}
